import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from '../../util/reactIntl';

import css from './VerificationBadges.module.css';
import IconBadge from '../IconBadge/IconBadge';
import { NamedLink } from '../../components'; // Make sure this path is correct

export const VerificationBadgesComponent = props => {
  const { user, isChatPage } = props;

  const isUserVerified = user?.attributes?.profile?.publicData?.isVerified;
  const isDobChecked = user?.attributes?.profile?.publicData?.dobChecked;

  return (
    <span className={`${css.badgeIcons} ${isChatPage ? css.chatPageUnverified : ''}`}>
      {isChatPage ? (
        <>
          Your profile is not yet fully verified. In order to be introduced to any counterparties, please
          submit your passport for KYC.{' '}
          <NamedLink name="UploadPassportPage">
            <span className={css.settingsLink}>Check here</span>
          </NamedLink>
        </>
      ) : (
        <>
          Member KYC status:{' '}{!isUserVerified && !isDobChecked && "unverified"}
          {isDobChecked && (
            <IconBadge width="1.5rem" height="1.5rem" isVerified={false} />
          )}
          {isUserVerified && (
            <IconBadge width="1.5rem" height="1.5rem" isVerified={true} />
          )}
        </>
      )}
    </span>
  );
};

VerificationBadgesComponent.propTypes = {
  user: PropTypes.object.isRequired,
  isChatPage: PropTypes.bool,
};

export default injectIntl(VerificationBadgesComponent);
